import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type ExternalContentPerformanceFragment = { entityId: string, id: string, status: Types.PerformanceStatusEnum, progress: number, estimatedTimeSpent?: number | null, type: Types.PerformanceTypeEnum, entityType: Types.PerformanceEntityTypeEnum, isAvailable: boolean, enrolmentInfo?: { dueDate?: string | null } | null };


export type ExternalContentPerformanceFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ExternalContentPerformanceFragmentDoc = /*#__PURE__*/ gql`
    fragment ExternalContentPerformance on ExternalContentPerformanceType {
  entityId
  id
  status
  progress
  estimatedTimeSpent
  type
  entityType
  isAvailable
  progress
  enrolmentInfo {
    dueDate
  }
}
    `;